import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '../shared/Button';

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [sidebarOpen]);

  return (
    <div className="fixed top-0 left-0 w-full h-full flex z-20">
      {sidebarOpen && (
        <div
          className="w-64 bg-white h-screen overflow-y-auto"
          onClick={stopPropagation}
        >
          <ul className="p-4">
            <Link to="/login">
              <Button type="solid" data="LOGIN" />
            </Link>
          </ul>
          <div className="flex justify-end w-30 h-30 mb-14 bg-opacity-80 rounded-full">
            <button className="px-4 py-2 bg-dark-secondary rounded-full">Day</button>
            <button className="px-4 py-2  ">Night</button>
          </div>
          <hr />
          <ul className='p-4'>
            <div>
              <li className="transition duration-200 ease-in hover:bg-gray-300 font-semibold py-2 cursor-pointer">Store Locator</li>
              <Link to='/track-order'>
                <li className="transition duration-200 ease-in hover:bg-gray-300 font-semibold py-2 cursor-pointer">Track Order</li>
              </Link>
              <Link to='/menu'>
                <li className="transition duration-200 ease-in hover:bg-gray-300 font-semibold py-2 cursor-pointer">Explore Menu</li>
              </Link>
            </div>
            <hr />
          </ul>
          <ul className='p-4'>
            <div>
              <li className="transition duration-200 ease-in hover:bg-gray-300 font-semibold py-2 cursor-pointer">About Us</li>
              <Link to='/feedBack'>
                <li className="transition duration-200 ease-in hover:bg-gray-300 font-semibold py-2 cursor-pointer">Feed Back</li>
              </Link>
              <Link to='/termscondition'>
                <li className="transition duration-200 ease-in hover:bg-gray-300 font-semibold py-2 cursor-pointer">Terms & Condition</li>
              </Link>
              <Link to='/privacy-policy'>
                <li className="transition duration-200 ease-in hover:bg-gray-300 font-semibold py-2 cursor-pointer">Privacy Policy</li>
              </Link>
              <Link to='/Contact-us'>
                <li className="transition duration-200 ease-in hover:bg-gray-300 font-semibold py-2 cursor-pointer">Contact Us</li>
              </Link>
              <Link to='/mitao-bhook'>
                <li className="transition duration-200 ease-in hover:bg-gray-300 font-semibold py-2 cursor-pointer">Mitao Bhook</li>
              </Link>
              <Link to='/mitao-bhook-scholarship'>
                <li className="transition duration-200 ease-in hover:bg-gray-300 font-semibold py-2 cursor-pointer">Mitao Bhook - Scholarship</li>
              </Link>
              <li className="transition duration-200 ease-in hover:bg-gray-300 font-semibold py-2 cursor-pointer">Careers</li>
            </div>
          </ul>
        </div>
      )}
      <div className="flex-1" onClick={closeSidebar}>
        {sidebarOpen && (
          <div className="w-full h-full bg-black opacity-50 absolute z-10"></div>
        )}
        <button
          className={`md:hidden block px-4 py-2 text-gray-700 ${sidebarOpen ? 'hidden' : 'block'
            }`}
          onClick={toggleSidebar}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
